import _ from "lodash";

const state = {
    flag: null,
    addingFlag: false,
    updatedFlag: null,
};

const getters = {
    addingFlag: state => state.addingFlag,
    activeFlag: state => state.flag,
    updatedFlag: state => state.updatedFlag,
    isFlagLoaded: state => state.flag !== null,
};


const mutations = {
    setAddFlag: (state, status) => {
        state.addingFlag = _.cloneDeep(status);
    },
    setActiveFlag: (state, flag) => {
        state.flag = _.cloneDeep(flag);
    },
    commitFlag: (state, flag) => {
        state.updatedFlag = _.cloneDeep(flag);
    },
};

export default {
    state,
    getters,
    mutations,
};
